/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Wealthlane_Shared_Hosting_Enums_TenantLockState {
    '_1' = 1,
    '_2' = 2,
}
